import { Routes, Route } from "react-router-dom";
import PublicRoutes from "./PublicRoutes";
import ClientProtectedRoutes from "./ClientProtectedRoutes";
import AdminRoutes from "./AdminRoutes";
import SuperAdminRoutes from "./SuperAdminRoutes";
import ProtectedRoute from "./ProtectedRoute";

const AppRoutes = () => (
  <Routes>
    {/* Public routes (no auth needed) */}
    {PublicRoutes}

    {/* Public routes ( auth needed) */}
    <Route
      element={<ProtectedRoute roles={["buyer-owner", "agent-builder"]} />}
    >
      {ClientProtectedRoutes}
    </Route>

    {/* Admin area (role-based) */}
    <Route
      element={<ProtectedRoute roles={["buyer-owner", "agent-builder"]} />}
    >
      {AdminRoutes}
    </Route>

    {/* Super-admin */}
    <Route
      element={<ProtectedRoute roles={["super-admin"]} />} //remove agentbuilder and buyer owner after development
    >
      {SuperAdminRoutes}
    </Route>
  </Routes>
);

export default AppRoutes;
